
    /**
    * 更新是否需要样品状态
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  /**
 * UpdateIsNeedSampleParam :UpdateIsNeedSampleParam
 */
export class IReqid18653 {
  /**
   * 带播单编号
   */
  waitingLiveNo?: {};
  /**
   * 是否需要样品
   */
  isNeedSample?: {};
}
  /**
 * YResult :YResult
 */
export class IResid18653 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18653, IResid18653 > = (data?) =>  request({
        method: 'POST',
        url: '/api/WaitingLiveItem/updateIsNeedSample',
        data: data
      }) 
  export default http